export default __webpack_public_path__ + "static/media/downChevron.f8dc61dc.svg";